import { IconButton } from "@mui/material";
import { SortableHandle } from "react-sortable-hoc";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";

const CustomDragHandle = SortableHandle(() => (
  <IconButton
    sx={{ cursor: "grab", zIndex: 10 }}
    onClick={(e) => e.stopPropagation()}
    onMouseDown={(e) => e.stopPropagation()}
  >
    <DragIndicatorIcon sx={{ verticalAlign: "middle" }}/>
  </IconButton>
));

export default CustomDragHandle;
